import { Injectable } from '@angular/core';
import { ConfigBaseFilter, ConfigService, ListLayout, ListLayoutMultipleComponent, ListSortOption } from 'gung-list';
import { ColmecTirePolicy, ColmecTirePolicyService } from './colmec-tire-policy.service';
import { Observable } from 'rxjs';
import { ColmecTirePolicyTableViewComponent } from '../components/tire-policy/colmec-tire-policy-table-view/colmec-tire-policy-table-view.component';

@Injectable({
  providedIn: 'root'
})
export class ColmecTirePolicyListConfigService implements ConfigService<ColmecTirePolicy> {
  topFilter = false;

  constructor(
    protected colmecTirePolicyService: ColmecTirePolicyService
  ) { }

  getFilters(): ConfigBaseFilter<ColmecTirePolicy>[] {
    return [];
  }

  getSortOptions(): ListSortOption<ColmecTirePolicy>[] {
    // TODO: implement
    return [];
  }

  getBatchSizes(): number[] {
    return [24];
  }

  getLayouts(): ListLayout<ColmecTirePolicy>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => ColmecTirePolicyTableViewComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'TirePolicyView'
      }
    ];
  }

  getItems(): Observable<ColmecTirePolicy[]> {
    return this.colmecTirePolicyService.getTirePolicies();
  }

  getItemId(item: ColmecTirePolicy) {
    return item.id;
  }

  getSearchTerms(item: ColmecTirePolicy) {
    return [item.id, item.customerId, item.customerName];
  }

  getNothingFoundTranslateTag(): string {
    return '';
  }
}
